export function goTo (destination) {
  window.location = destination
}

export function goToBlank (destination) {
  window.open(destination, '_blank')
}

export function parseSearchParams (search = location.search) {
  return new URLSearchParams(search)
}

export function replaceHistory (url) {
  history.replaceState(null, null, url)
}
